/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IFlashWallet, IFlashWalletInterface } from "../IFlashWallet";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "executeCall",
    outputs: [
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
    ],
    name: "executeDelegateCall",
    outputs: [
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

export class IFlashWallet__factory {
  static readonly abi = _abi;
  static createInterface(): IFlashWalletInterface {
    return new utils.Interface(_abi) as IFlashWalletInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IFlashWallet {
    return new Contract(address, _abi, signerOrProvider) as IFlashWallet;
  }
}
